import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { onSave, upsertTemplate } from './actions';
import styled from 'styled-components';

const FormContainer = styled.div`
  padding: 20px;
  margin-top: 2rem;
  margin-right: auto;
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  gap: 20px;

  .form-group {
    .form-control {
      max-width: 100%;
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    margin-top: 1rem;
    padding: 10px;
    max-width: 90%;
  }

  @media (max-width: 576px) {
    margin-top: 0.5rem;
    padding: 5px;
    max-width: 95%;
  }
`;

const ErrorMessage = styled.span`
  color: rgb(242, 108, 79);
  font-size: 0.875rem;
  line-height: 1.2;
  display: block;
  margin-top: 5px;
`;

class AddEditTemplate extends Component {
  state = {
    command: '',
    output: '',
    errors: {},
    isSaving: false,
  };

  componentDidMount() {
    const { template } = this.props;
    if (template) {
      this.setState({
        command: template.command || '',
        output: template.output || '',
      });
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { command, output } = this.state;
    const errors = {};

    if (!command.trim()) errors.command = 'Command is required';
    if (!output.trim()) errors.output = 'Output is required';

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ isSaving: true });
    const postData = this.props.template
      ? { templateId: this.props.template.id, command, output }
      : { command, output };

    const successCallback = (savedTemplate) => {
      this.props.upsertTemplate(savedTemplate);
      this.setState({ isSaving: false });
      this.props.history.push('/templates');
    };

    this.props.onSave(this.props.token, postData, successCallback);
  };

  render() {
    const { command, output, errors, isSaving } = this.state;
    const isEditing = !!this.props.template;

    return (
      <BlockUi blocking={isSaving}>
        <FormContainer>
          <h1>{isEditing ? 'Edit Template' : 'Create New Template'}</h1>
          <Form onSubmit={this.handleSubmit}>
            <FormGroup>
              <Label for="command">Title (Command)</Label>
              <Input
                type="text"
                name="command"
                id="command"
                value={command}
                onChange={this.handleChange}
                invalid={!!errors.command}
              />
              {errors.command && <ErrorMessage>{errors.command}</ErrorMessage>}
            </FormGroup>
            <FormGroup>
              <Label for="output">Content (Output)</Label>
              <Input
                type="textarea"
                name="output"
                id="output"
                value={output}
                onChange={this.handleChange}
                invalid={!!errors.output}
              />
              {errors.output && <ErrorMessage>{errors.output}</ErrorMessage>}
            </FormGroup>
            <Button
              type="submit"
              color="primary"
              style={{ marginRight: '10px' }}
            >
              Save
            </Button>
            <Button
              color="secondary"
              onClick={() => this.props.history.push('/templates')}
            >
              Cancel
            </Button>
          </Form>
        </FormContainer>
      </BlockUi>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const template =
    id === 'new'
      ? null
      : state.template.templates.find((t) => t.id === parseInt(id));
  return {
    template,
    token: state.main.user.token,
  };
};

const mapDispatchToProps = {
  onSave,
  upsertTemplate,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditTemplate);
